module.exports = __webpack_public_path__ + "media/ring-5.af35d00e.mp3";